import React from 'react';
import { motion } from 'framer-motion';

const DashboardLoading = () => {
  return (
    <div className="container mx-auto py-10 px-4 text-center min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-background to-secondary/5">
      <motion.div 
        initial={{ opacity: 0, scale: 0.8 }} 
        animate={{ opacity: 1, scale: 1 }} 
        transition={{ duration: 0.5, type: 'spring' }}
        className="p-8 rounded-xl bg-card shadow-2xl"
      >
        <svg 
          className="animate-spin h-12 w-12 text-primary mx-auto mb-6" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <h2 className="text-xl font-semibold text-foreground mb-2">Loading Dashboard</h2>
        <p className="text-muted-foreground">Please wait while we fetch your data...</p>
      </motion.div>
    </div>
  );
};

export default DashboardLoading;